import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import Select from "react-select";

export default class EssenceReferenceReportRoutineEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      report: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;

    let report = [];
    let reportQuery = await this.context.api.qa("/report/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(reportQuery)) {
      reportQuery.forEach((item) => {
        report.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    this.setState(
      {
        editData,
        pending: false,
        report,
      },
      () => this.triggerChange()
    );
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        definition: this.state.editData.definition || null,
        report: this.state.editData.report || null,
      });
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Отчет:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.report,
                      this.state.report
                    )}
                    onChange={(result) => this.onChange("report", result.value)}
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.report}
                    placeholder="Выберите..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Процедура:</label>
                  <input
                    onChange={(e) =>
                      this.onChange("definition", e.target.value)
                    }
                    className="form-control"
                    value={editData.definition || ""}
                  />
                </div>
              </div>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
